import Vue from 'vue';
import { HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import { LOAD_CLAIMS, RESET_CLAIMS } from "../const/claims";

export default {
  namespaced: true,
  state: {
    claims: {
      claims: [],
      pagination: {},
    },
  },
  getters: {
    claims: state => state.claims,
  },
  actions: {
    [LOAD_CLAIMS]: async ({ dispatch, commit }, { params, category }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_CLAIMS,
        namespace: 'claims',
        params,
        replace: { category },
      }, {root: true});
    },
  },
  mutations: {
    [LOAD_CLAIMS]: (state, { data }) => {
      Vue.set(state.claims, 'claims', data.claims);
      Vue.set(state.claims, 'pagination', data.pagination);
    },
    [RESET_CLAIMS]: (state) => {
      Vue.set(state, 'claims', {
        claims: [],
        pagination: {},
      });
    },
  },
};
